import { asyncAction, action } from 'now-frontend-shared/utils/actions';

export const getListingAnalytics = asyncAction('listingAnalytics/GET_ANALYTICS');

// sync actions
export const clearListingAnalyticsState = action('listingAnalytics/CLEAR_STATE');
